export default __webpack_public_path__ + "static/media/discover-logo.9d261438.png";